import { ApiBase, HTTPMethod, ResponseType } from '../api-base';
import { ResponseBase } from '../response-base';
import { ApiBaseBack } from '../back/api-base-back';

// front api は命名にメソッドをつける
export class ApiBaseFront<TResponseBody = any> extends ApiBase<ResponseBase<TResponseBody>> {

  private static _session: string;
  static set session(value: string) {
    this._session = value;
  }
  static get session(): string {
    return this._session;
  }

  private static _tmpRecaptcha: string;
  static set tmpRecaptcha(value: string) {
    this._tmpRecaptcha = value;
  }
  static get tmpRecaptcha(): string {
    return this._tmpRecaptcha;
  }

  private static _recaptchaV3: string;
  static set recaptchaV3(value: string) {
    this._recaptchaV3 = value;
  }
  static get recaptchaV3(): string {
    return this._recaptchaV3;
  }

  private static _recaptchaV2: string;
  static set recaptchaV2(value: string) {
    this._recaptchaV2 = value;
  }
  static get recaptchaV2(): string {
    return this._recaptchaV2;
  }

  private static _machineUuid: string;
  static set machineUuid(value: string) {
    this._machineUuid = value;
  }
  static get machineUuid(): string {
    return this._machineUuid;
  }

  protected get hostname(): string {
    return ApiBaseFront.hostname || '';
  };

  protected get protocol(): string {
    return ApiBaseFront.protocol || '';
  }

  get header(): { [key: string]: string | number | undefined } {
    const headers: { [key: string]: string } = {};
    if (ApiBaseFront._session) {
      headers['X-Session-Id'] = ApiBaseBack.session;
      headers['X-M-Session-Id'] = ApiBaseFront.session;
    }
    if (ApiBaseFront.recaptchaV3) {
      headers['X-Recaptcha-V3-Token'] = ApiBaseFront.recaptchaV3;
    }
    if (ApiBaseFront.recaptchaV2) {
      headers['X-Recaptcha-V2-Token'] = ApiBaseFront.recaptchaV2;
    }
    if (ApiBaseFront.tmpRecaptcha) {
      headers['X-Tmp-Recaptcha-Token'] = ApiBaseFront.tmpRecaptcha;
    }
    if (ApiBaseFront.machineUuid) {
      headers['X-Machine-Id'] = ApiBaseFront.machineUuid;
    }
    return headers;
  }

  constructor(
    method: HTTPMethod,
    path: string,
    responseType: ResponseType,
    param: Object,
    header?: { [key: string]: string | number | undefined },
    hostname?: string,
    protocol?: string,
  ) {
    const keyValueArr = (obj: Object, parentKey?: string): { key: string, value: any }[] => {
      const arr: any[] = [];
      Object.keys(obj).forEach((key, i) => {
        const value = (obj as any)[key];
        if (key === '[]') {
          arr.push({ key: parentKey ? `${parentKey}[]` : key, value });
        } else if (typeof value === 'string' || typeof value === 'number' || !value) {
          arr.push({ key: parentKey ? `${parentKey}[${key}]` : key, value });
        } else if (Array.isArray(value)) {
          const data = keyValueArr(value, `${parentKey ? parentKey : key}`);
          arr.push(...[...data].map((v) => ({ key: v.key, value: v.value })));
        } else if (value instanceof File) {
          arr.push({ key: parentKey ? `${parentKey}[${key}]` : key, value });
        } else {
          const data = keyValueArr(value, parentKey ? `${parentKey}[${key}]` : key);
          arr.push(...[...data].map((v) => ({ key: v.key, value: v.value })));
        }
      });
      return arr;
    };
    const object: any = {};
    const arr = keyValueArr(param);
    arr.forEach((v) => {
      object[v.key] = v.value;
    });
    super(
      method,
      path,
      responseType,
      object,
      header,
      hostname,
      protocol,
    );
  }

  public createHeader() {
    const header = new Headers();
    const keys = Object.keys(this.header || {});
    const values = Object.values(this.header || {});
    for (let i = 0; i < keys.length; i += 1) {
      if (values[i] !== undefined && keys[i] !== 'Content-Type') {
        header.append(keys[i], values[i] as string);
      }
    }
    return header;
  }

}